import { Button } from '@mui/material'
import AlphabetGrid from '../AlphabetGrid';
import { useState } from 'react';
import MultiplicativeCipherEncryption from './MultiplicativeCipherEncryption';
import MultiplicativeCipherDecryption from './MultiplicativeCipherDecryption';
import CustomButton from '../CustomButton';
// import PlayArrowRoundedIcon from '@mui/icons-material/PlayArrowRounded';

const MultiplicativeCipherSimulation = () => {
    const [selectedPlain, setPlain] = useState("")
    const [selectedCipher, setCipher] = useState("")
    const [plainText, setPlainText] = useState("")
    const [cipherText, setCipherText] = useState("")
    const [plainPos, setPlainPos] = useState("")
    const [cipherPos, setCipherPos] = useState("")
    const [key, setKey] = useState("")
    const [isKeyValid, setIsKeyValid] = useState(true)
    const [clickedSimulate, setClickedSimulate] = useState(false)
    const [isSimulating, setIsSimulating] = useState(false);

    function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    function find_mod_inv(a, m) {
        for (let x = 1; x < m; x++) {
            if ((a % m) * (x % m) % m === 1) {
                setIsKeyValid(true)
                return x;
            }
        }
        setIsKeyValid(false)
        setIsSimulating(false);
        return "error"
    }

    const encrypt = async (text, s) => {

        let result = ""
        var PosStr = ""
        setPlainText("")
        setCipherText("")
        setPlainPos("")
        setCipherPos("")
        setKey(s.toString())
        for (let i = 0; i < text.length; i++) {
            let char = text[i];
            setPlain(char)
            setPlainText(text.substring(0, i + 1))

            if (char.toUpperCase(text[i])) {
                PosStr = PosStr + ((char.charCodeAt(0) - 65) % 26).toString() + "#";
                setPlainPos(PosStr)
                let ch = String.fromCharCode((char.charCodeAt(0) * s - 65) % 26 + 65);
                setCipher(ch);
                result += ch;
                setCipherText(result)
                await sleep(2000).then(() => {

                })
            }
            else {
                PosStr = PosStr + ((char.charCodeAt(0) - 97) % 26).toString() + "#";
                setPlainPos(PosStr)
                let ch = String.fromCharCode((char.charCodeAt(0) * s - 97) % 26 + 97);
                setCipher(ch);
                result += ch;
                setCipherText(result)
                await sleep(2000).then(() => {

                })
            }

        }
        setIsSimulating(false);
        return result;
    }

    function handleSubmit(e) {
        // Prevent the browser from reloading the page
        e.preventDefault();
        if (!isSimulating) {
            setIsSimulating(true);
            // Read the form data
            const form = e.target;
            const formData = new FormData(form);

            // You can pass formData as a fetch body directly:
            // fetch('/some-api', { method: form.method, body: formData });

            // Or you can work with it as a plain object:
            const formJson = Object.fromEntries(formData.entries());
            console.log(formJson);

            var k = find_mod_inv(parseInt(formData.get("key")), 26)
            if (k !== "error") {
                var res = encrypt(formData.get("plaintext").toUpperCase(), parseInt(formData.get("key")));
                setClickedSimulate(true)
                console.log(res);
            }
        }
    }

    return (
        <>
            <form method="post" onSubmit={handleSubmit}>
                <label>
                    Plain Text (only alphabets, without spaces):
                    <input pattern="[a-zA-Z]+" required={true} style={{ textTransform: "uppercase" }} name="plaintext" />
                </label>
                <label>
                    Key (co-prime of 26):
                    <input name="key" required={true} type="number" />
                    <p style={{ display: isKeyValid ? "none" : "inline", color: "red" }}>Invalid Key!</p>
                </label>
                <CustomButton type="submit" isSimulating={isSimulating}>{isSimulating ? 'Simulating...' : 'Simulate'}</CustomButton>
                {/* <Button variant="contained" type='submit' size='medium' disabled={isSimulating}>{isSimulating ? 'Simulating...' : 'Simulate'}</Button> */}
            </form>
            <br />
            <br />
            <br />
            <AlphabetGrid selectedPlain={selectedPlain} selectedCipher={selectedCipher} />
            <div style={{ display: clickedSimulate ? "block" : "none" }} >
                <MultiplicativeCipherEncryption plainText={plainText} cipherText={cipherText} plainPos={plainPos} shift={key} />
            </div>
            <div style={{ display: clickedSimulate ? "block" : "none" }} >
                <hr />
                <MultiplicativeCipherDecryption plainText={plainText} cipherText={cipherText} plainPos={plainPos} shift={key} />
            </div>
        </>
    )
}

export default MultiplicativeCipherSimulation